"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
// components
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const household_component_1 = __importDefault(require("./household-component"));
const household_edit_1 = __importDefault(require("./household-edit"));
const household_member_create_container_1 = __importDefault(require("./household-member-create-container"));
// css
require("./households.scss");
class FamilySettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showHouseholdEdit: false,
            showAddMemberModal: false,
        };
        this.onCreate = this.onCreate.bind(this);
        this.showHouseholdEdit = this.showHouseholdEdit.bind(this);
        this.closeHouseholdEdit = this.closeHouseholdEdit.bind(this);
        this.onAddMemberClicked = this.onAddMemberClicked.bind(this);
        this.closeMemberEditor = this.closeMemberEditor.bind(this);
    }
    componentDidMount() {
        const { profileHasPerson, submitProfileForm, currentProfile, appFeedbackMessageError, history } = this.props;
        const profileLoaded = currentProfile && currentProfile.id;
        if (profileLoaded && !profileHasPerson) {
            try {
                submitProfileForm(currentProfile, true, true);
            }
            catch (error) {
                history.replace('/settings/profile');
                // this error is popping up randomly, need to find a way to reproduce it
                return appFeedbackMessageError('Last name required before you can proceed');
            }
        }
    }
    onCreate() {
        this.showHouseholdEdit();
    }
    renderHouseholdCreate() {
        return (React.createElement("div", { className: "household" },
            React.createElement("div", { className: "header" },
                React.createElement("h3", null, "Your Household")),
            React.createElement("div", { className: "Panel" },
                React.createElement("div", { className: "Grid Grid--withGutter u-padMd" },
                    React.createElement("div", { className: "Grid-cell u-size1of3" },
                        React.createElement("img", { src: "/images/team-pic.jpg" })),
                    React.createElement("div", { className: "Grid-cell u-size2of3" },
                        React.createElement("h3", null, "Need to start your own household?"),
                        React.createElement("p", null,
                            "Households make it easier to view and manage your family members within TeamSnap.",
                            ' ',
                            React.createElement("a", { href: "https://helpme.teamsnap.com/article/732-understanding-households", target: "_blank" }, "Learn more about households"),
                            "."),
                        React.createElement(teamsnap_ui_1.Button, { color: "primary", icon: 'plus', onClick: this.onCreate }, "Create My Household"))))));
    }
    showHouseholdEdit() {
        this.setState({ showHouseholdEdit: true });
    }
    closeHouseholdEdit() {
        this.setState({ showHouseholdEdit: false });
    }
    onAddMemberClicked() {
        this.setState({ showAddMemberModal: true });
    }
    closeMemberEditor() {
        this.setState({ showAddMemberModal: false });
    }
    render() {
        const { householdOwnedByUser, householdsNotOwnedByUser, history, submitHouseholdForm, deleteHouseholdPerson, currentProfile, resendInvite, deleteInvite, setSelectedMember, loadContactInfos, } = this.props;
        const { showHouseholdEdit, showAddMemberModal } = this.state;
        return (React.createElement("div", { id: "households" },
            householdOwnedByUser && (React.createElement(household_component_1.default, { household: householdOwnedByUser, currentProfile: currentProfile, deleteHouseholdPerson: deleteHouseholdPerson, resendInvite: resendInvite, deleteInvite: deleteInvite, setSelectedMember: setSelectedMember, user: this.props.user, ownedByUser: true, history: history, submitHouseholdForm: submitHouseholdForm, loadContactInfos: loadContactInfos, onAddMemberClicked: this.onAddMemberClicked })),
            (0, lodash_1.map)(householdsNotOwnedByUser, (h) => (React.createElement(household_component_1.default, { key: h.id, household: h, currentProfile: currentProfile, deleteHouseholdPerson: deleteHouseholdPerson, resendInvite: resendInvite, deleteInvite: deleteInvite, user: this.props.user, setSelectedMember: setSelectedMember, ownedByUser: false, history: history, submitHouseholdForm: submitHouseholdForm, loadContactInfos: loadContactInfos, onAddMemberClicked: this.onAddMemberClicked }))),
            !householdOwnedByUser && this.renderHouseholdCreate(),
            showAddMemberModal && (React.createElement(household_member_create_container_1.default, { history: this.props.history, closeMemberEditor: this.closeMemberEditor })),
            showHouseholdEdit && (React.createElement(household_edit_1.default, { initialValues: { name: currentProfile.lastName }, submitHouseholdForm: submitHouseholdForm, closeHouseholdEdit: this.closeHouseholdEdit }))));
    }
}
exports.default = FamilySettings;
